import datos from "src/services/datos";

/**
 * Obtiene el precio de un artículo para un cliente específico,
 * respetando el orden de prioridad configurado en SIAM:
 * 1. cuentas_articulos
 * 2. tipo_cuentas_articulos
 * 3. articulos_calculo_precios
 *
 * @param {string} alias       - Alias del artículo (ej: "PLANILLADO", "FLETE_RET", "FLETE_DEV")
 * @param {number} id_cuentas  - ID de la cuenta/cliente
 *
 * @returns {Promise<number>}  - Precio resuelto, o 0 si no se encuentra
 */
export const getPrecioArticulo = async (alias, id_cuentas) => {
  try {
    const service = new datos("articulos");
    const response = await service.articulosGetPrecio({ alias, id_cuentas });

    if (response?.status === "true" && response?.wsResponse?.precio !== undefined) {
      return parseFloat(response.wsResponse.precio) || 0;
    }
    return 0;
  } catch {
    return 0;
  }
};
